export class Municipality {
    public idMunicipality: number;
    public municipalityName: string;
    public latitude: string;
    public longitude: string;
}
